import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { droppedStickersApi } from '~/Providers/Api';
import TextInput from '~/Components/Global/Form/TextInput';
import moment from '~/Providers/Moment';
import NoScrollBar from '../NoScrollBar/NoScrollBar';
import StickerDrag from './StickerDrag';

import '~/Components/Global/Form/TextInput.scss';

const minSearchLength = 1;

const useSearch = term => {
  const [stickers, setStickers] = useState([]);
  const interval = useRef();
  const request = useRef();

  useEffect(() => {
    if (interval.current) clearTimeout(interval.current);
    interval.current = setTimeout(() => {
      const stamp = moment().unix();
      request.current = stamp;
      if (term.length < minSearchLength) {
        term = null;
      }
      droppedStickersApi.search(term).then(results => {
        if (request.current !== stamp) {
          return;
        }
        setStickers(results.data);
      });
    }, 300);
  }, [term]);
  return stickers;
};

const SearchStickers = props => {
  const [currentSearch, setSearch] = useState('');
  const results = useSearch(currentSearch);

  const clear = () => {
    setSearch('');
  };

  return (
    <div className="search-sticker-wrapper">
      <TextInput
        className="minimal-input search-input"
        placeholder="Search"
        value={currentSearch}
        onChange={({ search }) => {
          setSearch(search);
        }}
        onKeyDown={({ key }) => key === 'Escape' && clear()}
        autoFocus
        name="search"
      />
      <a className="clear-btn material-icons" onClick={props.onClose}>
        close
      </a>
      <div className="sticker-packs search">
        <NoScrollBar showScrollOnHover>
          <div className="sticker-pack search">
            {results.map((sticker, index) => (
              <StickerDrag
                showDelete={false}
                sticker={{
                  ...sticker,
                  pivot: { sticker_id: sticker.id, sticker_pack_id: sticker.sticker_pack_id },
                }}
                key={index}
              />
            ))}
          </div>
        </NoScrollBar>
      </div>
    </div>
  );
};

SearchStickers.propTypes = {
  onClose: PropTypes.func,
};

export default SearchStickers;
